import {IconSize, IconSizes} from '../../icon/Icon';
import {i18n} from '../../../i18n/i18n';

/**
 * Predefined item decoration icons.
 */
export const ListViewItemDecorationIcon = {
  CHEVRON:         'fa-chevron-right',
  COPY:            'fa-copy fa-regular',
  EDIT:            'fa-pen-to-square',
  ELLIPSIS:        'fa-ellipsis',
  EXTERNAL_LINK:   'fa-arrow-up-right-from-square',
  POPUPMENU:       'fa-bars',
  OPTION_SELECTED: 'fa-circle-dot fa-regular',
  OPTION_EMPTY:    'fa-circle fa-regular'
};

/**
 * Describes an item decoration.
 */
export interface ListViewItemDecoration {
  icon: string;
  size?: IconSize;
  ariaLabel?: string;
}

/**
 * Describes an item affix.
 */
export interface ListViewItemAffix {
  label: string;
}

/**
 * Provides a collection of default item decorations.
 */
export const DefaultItemDecorations: { [key: string]: ListViewItemDecoration } = {
  CHEVRON:         {
    icon:      ListViewItemDecorationIcon.CHEVRON,
    size:      IconSizes.SMALL,
    ariaLabel: i18n().itemDecorations.chevron
  },
  COPY:            {
    icon:      ListViewItemDecorationIcon.COPY,
    size:      IconSizes.SMALL,
    ariaLabel: i18n().itemDecorations.copy
  },
  EDIT:            {
    icon:      ListViewItemDecorationIcon.EDIT,
    size:      IconSizes.SMALL,
    ariaLabel: i18n().itemDecorations.edit
  },
  ELLIPSIS:        {
    icon:      ListViewItemDecorationIcon.ELLIPSIS,
    size:      IconSizes.SMALL,
    ariaLabel: i18n().itemDecorations.ellipsis
  },
  EXTERNAL_LINK:   {
    icon:      ListViewItemDecorationIcon.EXTERNAL_LINK,
    size:      IconSizes.SMALL,
    ariaLabel: i18n().itemDecorations.externalLink
  },
  OPTION_SELECTED: {
    icon:      ListViewItemDecorationIcon.OPTION_SELECTED,
    size:      IconSizes.SMALL,
    ariaLabel: i18n().itemDecorations.optionSelected
  },
  OPTION_EMPTY:    {
    icon:      ListViewItemDecorationIcon.OPTION_EMPTY,
    size:      IconSizes.SMALL,
    ariaLabel: i18n().itemDecorations.optionEmpty
  },
  POPUPMENU:       {
    icon:      ListViewItemDecorationIcon.POPUPMENU,
    size:      IconSizes.SMALL,
    ariaLabel: i18n().itemDecorations.popupmenu
  }
};
